import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import CommonButton from '@src/new-components/Button';
import { ImportContactsRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { ONBOARDING_POPUP_TYPE } from '@src/constants';
import { StyledProjectHeader } from './index.style';

const ProjectHeader = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getFeatureValue } = useFeatureFlags();
  const user = useSelector((state) => state.auth.user);

  const onboardingPopupEnabled = getFeatureValue(
    FEATURE_KEYS.ONBOARDING_POPUP,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );
  return (
    <StyledProjectHeader>
      <div className="title-wrapper">
        <Typography className="title">{t('project')}</Typography>
        {onboardingPopupEnabled && (
          <CommonButton
            startIcon={
              <ImportContactsRounded
                sx={{ fontSize: '24px', color: COLOR.navyBlue }}
              />
            }
            variant="outlined"
            className="dialog-actions-button"
            sx={{
              border: `1px solid ${COLOR.secondary[16]}`,
              padding: '10px 16px',
              borderRadius: '8px',
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.indigo.default,
            }}
            onClick={() => {
              dispatch(
                actions.onboardingPopup.showOnboardingPopup({
                  type: ONBOARDING_POPUP_TYPE.PROJECT,
                }),
              );
            }}
          >
            {t('onboardingViewGuideDetail')}
          </CommonButton>
        )}
      </div>
    </StyledProjectHeader>
  );
};

export default ProjectHeader;
